import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row mb-25 pb-18 align-items-end br-1 gx-0" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "mb-0" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "breadcrumb-menu list-style lh-base text-md-end" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 3,
  class: "active"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.translatedTitle), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("ul", _hoisted_5, [
        (_ctx.showHome)
          ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('dashboard')), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.items && _ctx.items.length > 0)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: `${item.label}-${index}`,
                class: _normalizeClass({ active: index === _ctx.items.length - 1 })
              }, [
                (item.to && index < _ctx.items.length - 1)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: item.to
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t(item.label)), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.t(item.label)), 1))
              ], 2))
            }), 128))
          : (_ctx.paths && _ctx.paths.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.paths, (path, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: _normalizeClass({ active: index === _ctx.paths.length - 1 })
                }, [
                  (index < _ctx.paths.length - 1)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: '/'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t(path)), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.t(path)), 1))
                ], 2))
              }), 128))
            : (_ctx.pageTitle)
              ? (_openBlock(), _createElementBlock("li", _hoisted_9, _toDisplayString(_ctx.translatedTitle), 1))
              : _createCommentVNode("", true)
      ])
    ])
  ]))
}